import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "./Reveal";
import { FAQS } from "../../lib/content";

export const Faq = () => (
  <section id="faq" className="bg-white py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-4">
        <Reveal className="lg:sticky lg:top-32">
          <p className="overline mb-4">FAQ</p>
          <h2 className="font-heading text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
            Questions, answered plainly.
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-heading text-base font-medium text-[#0A0C14] hover:text-[#3B5FE8] hover:no-underline lg:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-600 lg:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
